module.exports = __webpack_public_path__ + "img/gate-rail-horizontal-right.94364533.png";